var map = {
	"./calendar-carousels": [
		8984,
		6215,
		7144
	],
	"./calendar-carousels-v2": [
		1357,
		6215,
		6369
	],
	"./calendar-carousels-v2.js": [
		1357,
		6215,
		6369
	],
	"./calendar-carousels.js": [
		8984,
		6215,
		7144
	],
	"./carousels": [
		9661,
		6215,
		2173
	],
	"./carousels.js": [
		9661,
		6215,
		2173
	],
	"./editorial-list-load-more": [
		7895,
		1217
	],
	"./editorial-list-load-more.js": [
		7895,
		1217
	],
	"./favorites-news": [
		9919,
		3274,
		6215,
		8305
	],
	"./favorites-news.js": [
		9919,
		3274,
		6215,
		8305
	],
	"./infinite-article": [
		575,
		6215,
		4577
	],
	"./infinite-article.js": [
		575,
		6215,
		4577
	],
	"./lang-dropdown": [
		5756,
		1138
	],
	"./lang-dropdown.js": [
		5756,
		1138
	],
	"./lazy-load-sample-module": [
		3523,
		6703
	],
	"./lazy-load-sample-module.js": [
		3523,
		6703
	],
	"./local-number": [
		1227,
		1633
	],
	"./local-number.js": [
		1227,
		1633
	],
	"./local-time": [
		9975,
		3253
	],
	"./local-time.js": [
		9975,
		3253
	],
	"./login-welcome-page": [
		4388,
		3274,
		9428
	],
	"./login-welcome-page.js": [
		4388,
		3274,
		9428
	],
	"./match-live-update": [
		6450,
		6364
	],
	"./match-live-update.js": [
		6450,
		6364
	],
	"./modal": [
		3983,
		5479
	],
	"./modal.js": [
		3983,
		5479
	],
	"./play-games-link": [
		3021,
		3274,
		7993
	],
	"./play-games-link.js": [
		3021,
		3274,
		7993
	],
	"./player-favorites": [
		4889,
		3274,
		5603
	],
	"./player-favorites.js": [
		4889,
		3274,
		5603
	],
	"./player-header": [
		2267,
		3274,
		51
	],
	"./player-header.js": [
		2267,
		3274,
		51
	],
	"./player-stats": [
		5263,
		893
	],
	"./player-stats.js": [
		5263,
		893
	],
	"./player-tournaments": [
		1476,
		8212
	],
	"./player-tournaments.js": [
		1476,
		8212
	],
	"./players-rankings-module": [
		9051,
		3274,
		5335
	],
	"./players-rankings-module.js": [
		9051,
		3274,
		5335
	],
	"./social-icons": [
		6284,
		2704
	],
	"./social-icons.js": [
		6284,
		2704
	],
	"./tournament-calendar": [
		6570,
		3816
	],
	"./tournament-calendar.js": [
		6570,
		3816
	],
	"./tournament-draws": [
		329,
		6364,
		1179
	],
	"./tournament-draws.js": [
		329,
		6364,
		1179
	],
	"./tournament-header": [
		2173,
		4437
	],
	"./tournament-header-v2": [
		5762,
		9866
	],
	"./tournament-header-v2.js": [
		5762,
		9866
	],
	"./tournament-header.js": [
		2173,
		4437
	],
	"./tournament-matches-list": [
		9340,
		6364,
		2990
	],
	"./tournament-matches-list.js": [
		9340,
		6364,
		2990
	],
	"./tournament-scores": [
		3243,
		6364,
		735
	],
	"./tournament-scores-live": [
		7354,
		7966
	],
	"./tournament-scores-live.js": [
		7354,
		7966
	],
	"./tournament-scores-v2": [
		6068,
		6364,
		9976
	],
	"./tournament-scores-v2.js": [
		6068,
		6364,
		9976
	],
	"./tournament-scores.js": [
		3243,
		6364,
		735
	],
	"./tournaments-list": [
		5935,
		7017
	],
	"./tournaments-list.js": [
		5935,
		7017
	],
	"./user-account": [
		8089,
		3274,
		6651
	],
	"./user-account.js": [
		8089,
		3274,
		6651
	],
	"./video-details-module": [
		8135,
		4245
	],
	"./video-details-module.js": [
		8135,
		4245
	],
	"./video-player": [
		5407,
		5349
	],
	"./video-player-iframe": [
		8776,
		8434
	],
	"./video-player-iframe.js": [
		8776,
		8434
	],
	"./video-player.js": [
		5407,
		5349
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5457;
module.exports = webpackAsyncContext;